/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-danger */

import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import Spinner from '../../../components/Spinner'
import PercentageFormat from '../../../components/PercentageFormat'
import Currency from '../../../components/Currency'
import NumberFormat from '../../../components/NumberFormat'

export const InitialLoaderComponent = () => (
    <div style={{ width: '100%', textAlign: 'center' }}>
        <Spinner />
    </div>
)

export const customHitStats = props => {
    const { bemBlocks, hitsCount, timeTaken } = props
    return (
        <div className={bemBlocks.container()} data-qa="hits-stats">
            <div className={bemBlocks.container('info')} data-qa="info">
                {hitsCount.toLocaleString()} results found in {timeTaken}ms
            </div>
        </div>
    )
}

// eslint-disable-next-line
export class EventHitsTable extends React.Component {
    render() {
        const { hits, addToCompare } = this.props
        return (
            <tbody>
                {hits.map(hit => {
                    const source = {
                        ...hit._source,
                        ...hit.highlight,
                        nameWithoutHighlight: hit._source.name,
                        venueNameWithoutHighlight: hit._source.venueName,
                    }

                    const venue = `${source.venueName} (${source.venueState})`
                    return (
                        <tr key={hit._id} className="eventTableRow">
                            <td style={{ width: '25%' }}>
                                <div>
                                    <Link to={`/events/${hit._id}`}>
                                        <span
                                            title={source.name}
                                            className="event-name"
                                            dangerouslySetInnerHTML={{
                                                __html: source.name,
                                            }}
                                        />
                                    </Link>
                                </div>
                                <a
                                    onClick={() => addToCompare(source)}
                                    className="actionlink"
                                >
                                    <i
                                        className="fa fa-balance-scale m-r-xs"
                                        aria-hidden="true"
                                    ></i>
                                    Add to comparison
                                </a>
                            </td>
                            <td style={{ width: '120px' }}>
                                {moment(source.eventStartDate).format(
                                    'DD MMM YYYY',
                                )}
                            </td>
                            <td style={{ width: '130px' }}>
                                <span title={venue}>
                                    <span
                                        className="venue-name"
                                        dangerouslySetInnerHTML={{
                                            __html: venue,
                                        }}
                                    />
                                </span>
                            </td>
                            <td className="table-number">
                                <NumberFormat
                                    value={hit._source.ticketsAvailable}
                                />
                            </td>
                            <td className="table-number">
                                <NumberFormat value={hit._source.ticketsSold} />
                            </td>
                            <td className="table-number">
                                <NumberFormat
                                    value={hit._source.ticketsSoldToday}
                                />
                            </td>
                            <td className="table-number">
                                <NumberFormat
                                    value={hit._source.ticketsRemaining}
                                />
                            </td>
                            <td className="table-number">
                                <Currency value={hit._source.ticketsValue} />
                            </td>
                            <td className="table-number">
                                <PercentageFormat
                                    value={hit._source.percentSold}
                                />
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        )
    }
}
